import {Component, inject} from '@angular/core';
import {
    MAT_SNACK_BAR_DATA,

    MatSnackBarRef
} from '@angular/material/snack-bar';
import {NgClass} from '@angular/common';
import {InfoMessageModel} from '../../models/info-message/info-message.model';

@Component({
  selector: 'app-info-message',
  imports: [NgClass],
  templateUrl: './info-message.component.html',
  styleUrl: './info-message.component.sass'
})
export class InfoMessageComponent {
    snackBarRef = inject(MatSnackBarRef)
    infoMessageModel: InfoMessageModel = inject(MAT_SNACK_BAR_DATA) as InfoMessageModel
}
